import { Currency } from '@seapoint/server/enums';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';
import { getAmountWithCurrency } from '../../../utils/get-amount-with-currency';

type AccountSummaryCardProps = {
  id: string;
  bankName: string;
  bankLogo: string;
  currency: Currency;
  balance: number;
  isSelected: boolean;
  onSelect: (id: string) => void;
};

export const AccountSummaryCard = ({
  id,
  bankName,
  bankLogo,
  currency,
  balance,
  isSelected,
  onSelect,
}: AccountSummaryCardProps) => {
  const accountBalance = getAmountWithCurrency({ amount: balance, currency, isAccountBalance: true });

  return (
    <button
      className={`relative flex w-72 rounded-xl border-2 px-4 py-3 ${isSelected ? 'border-seapoint-yellow bg-white' : 'border-transparent bg-seapoint-gray-background-modal'} h-full`}
      onClick={() => onSelect(id)}
    >
      <Stack space={1} className="w-full">
        <Inline space={2} justify="between" align="center" className="w-full">
          <h2 className="flex-1 truncate text-left text-sm font-medium text-black">
            {bankName} ({currency.toUpperCase()})
          </h2>
          <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-clip rounded-full">
            <img src={bankLogo} alt={`${bankName} logo`} loading="eager" fetchPriority="high" />
          </div>
        </Inline>
        <p className="text-left text-xl font-medium text-black">{accountBalance}</p>
      </Stack>
    </button>
  );
};
